export default "__VITE_ASSET__f5b44219__"